import { DOCUMENT, NgClass, NgIf } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, viewChild, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserComponent } from 'app/layout/layouts/horizontal/spezia/user/user.component';
import { Subject, takeUntil } from 'rxjs';
import { FooterMenuComponent } from './footer-menu/footer-menu.component';
import { FooterColumnsComponent } from './footer-columns/footer-columns.component';
import { FooterLinksComponent } from './footer-links/footer-links.component';
import { SocialLinksComponent } from './social-links/social-links.component';
import { LogoComuneComponent } from './logo-comune/logo-comune.component';
import { BreadcrumbComponent } from 'app/layout/common/breadcumb/breadcrumb.component';
import { checkModifica, authLink } from 'app/utils/boolean-input';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { StepperRatingComponent } from 'app/modules/stepper-rating/stepper-rating.component';

@Component({
    selector     : 'spezia-h-layout',
    templateUrl  : './spezia-h.component.html',
    encapsulation: ViewEncapsulation.None,
    styles:[
      `
      .sanlazzaro-color{
        color:red
      }
      `
    ],
    standalone   : true,
    imports      : [BreadcrumbComponent, StepperRatingComponent, LogoComuneComponent, SocialLinksComponent, NgClass, FuseLoadingBarComponent, FooterMenuComponent, FooterColumnsComponent, FooterLinksComponent, NgIf, FuseVerticalNavigationComponent, FormlyModule, ReactiveFormsModule, FuseHorizontalNavigationComponent, MatButtonModule, MatIconModule, UserComponent, RouterOutlet],
})
export class SpeziaHLayout implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    navMenu: FuseNavigationItem[];
    dataMenu: any;
    scrolled:boolean = false;
    lastScrollTop = 0;

    istanza:Istanza;


    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _activatedRoute: ActivatedRoute,
        private _istanzeService: IstanzeService,
        @Inject(DOCUMENT) private _document: Document
    ){}

    @ViewChild('page') mypage: ElementRef;


    scrollToAnchor(id: string): void {
        this._document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start', });
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
      let st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        // Scrolling verso il basso
        this.scrolled = true;
      } else {
        // Scrolling verso l'alto
        this.scrolled = st > 0;
      }
      this.lastScrollTop = st <= 0 ? 0 : st; // Per gestire lo scrolling su dispositivi mobili
    }

    form = new FormGroup({});
    model: any = {};
    options: FormlyFormOptions = {
      formState: {
        awesomeIsForced: false,
      },
    };
    fields: FormlyFieldConfig[] = [
      {
        key: 'text',
        type: 'input',
        props: {
          label: 'Text',
          placeholder: 'Formly is terrific!',
          required: true,
        },
      },
    ];
    /**
     * On init
     */
    ngOnInit(): void
    {

        this._activatedRoute.data.subscribe(d => {

        })

        this._istanzeService.istanza$.subscribe(istanza=>this.istanza=istanza)


        // Subscribe to navigation data
        this._navigationService.dataMenu$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((dataMenu: any) =>
            {


                dataMenu.principale.map((item=>{
                    item.function = checkModifica;
                    item.link = authLink(item.link)
                }))
                dataMenu.secondario.map((item=>{
                    item.function = checkModifica;
                    item.link = authLink(item.link)
                }))

                const menu:FuseNavigationItem[] = dataMenu.principale;
                menu.push(
                    { type : 'spacer',
                        classes: {
                            wrapper: 'px-20'
                        }
                    });

                this.navMenu = menu.concat(dataMenu.secondario);

                this.dataMenu = dataMenu;

            });





        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
